module.exports = __webpack_public_path__ + "assets/img/a604e455a74f56442c47cf940e2ecc83.png";